import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Download } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { imgSrc } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/partnership", label: "City BOND" },
  { to: "/manufacturing", label: "Manufacturing" },
  { to: "/projects", label: "Projects" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { content } = useContent();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const downloadBrochure = (e) => {
    e.preventDefault();
    alert("Brochure will be available shortly. Please contact us for the latest catalogue.");
  };

  return (
    <header data-testid="site-navbar" className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "glass-nav" : "bg-white/60 backdrop-blur-md"}`}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          {content.site.logo_image ? (
            <img src={imgSrc(content.site.logo_image)} alt={content.site.name} className="h-10 w-auto max-w-[140px] object-contain" />
          ) : (
            <div className="w-10 h-10 bg-[#1A1A1A] flex items-center justify-center">
              <span className="font-display text-[#D4AF37] text-xl leading-none">V</span>
            </div>
          )}
          <div className="leading-tight">
            <div className="font-display text-base sm:text-lg text-[#1A1A1A]">{content.site.name.split(" ")[0] || "Victory"}</div>
            <div className="tracking-eyebrow text-[#4B5563] text-[10px]">{content.site.tagline}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `va-link text-sm font-medium text-[#1A1A1A] ${isActive ? "active" : ""}`} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button data-testid="nav-download-brochure" onClick={downloadBrochure}
            className="btn-charcoal px-5 py-2.5 text-xs tracking-widest uppercase font-semibold flex items-center gap-2">
            <Download className="w-3.5 h-3.5" /> Brochure
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="lg:hidden p-2 text-[#1A1A1A]" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden glass-nav border-t border-[#E5E7EB]">
          <nav className="flex flex-col px-6 py-4">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `py-3 text-sm font-medium border-b border-[#E5E7EB] ${isActive ? "text-[#D4AF37]" : "text-[#1A1A1A]"}`} end={l.to === "/"}>
                {l.label}
              </NavLink>
            ))}
            <button data-testid="mobile-download-brochure" onClick={downloadBrochure} className="btn-charcoal mt-4 px-5 py-3 text-xs tracking-widest uppercase font-semibold">
              Download Brochure
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
